<template>
  <!-- the steps text needs its own component -->
  <div
    id="customs-vmodal-header-title"
    :class="['columns ugc-top-bar-steps-view-instructions',
      { 'small-9': !$store.state.utils.configuration.enableNewUgcModal && !customizerHeaderUGCLargeButton },
      { 'small-8': !$store.state.utils.configuration.enableNewUgcModal && customizerHeaderUGCLargeButton },
    ]"
  >
    {{ translations.ugcStep }} {{ currentStep }} {{ translations.ugcStepOf }}
    {{ totalSteps }} {{ translations.ugcStepEnd }}: {{ getTitle }} <br />
    {{ getSubTitle }} {{ displayViewText }}
  </div>
</template>
<script>
export default {
  name: "UgcStepsView",
  data() {
    return {
      displayViewText: ""
    };
  },
  props: {
    customizerHeaderUGCLargeButton: {
      // TODO: refactor and rename this in VFDP-115984, leverage caid configuration.json
      type: Boolean,
      default: false
    },
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    currentStep() {
      return (this.getCurrentUgcView + 1) <= this.totalSteps ? (this.getCurrentUgcView + 1) : this.totalSteps;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    getUgcFlowViews() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugcFlowViews;
    },
    totalSteps() {
      return this.getUgcFlowViews.length - 1;
    },
    getCurrentUgcView() {
      return this.$store.state.ugc.stateManager.currentUgcView;
    },
    getUgcFlowComponents() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugcFlowComponents;
    },
    getTitle() {
      if (
        this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-almost-done"
        || this.getUgcFlowViews[this.getCurrentUgcView] == "new-ugc-almost-done"
      ) {
        return this.translations.ugcInterModalHeader;
      } else if (
        this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-confirm-design"
      ) {
        return this.translations.ugcConfirmHeader;
      }
      return this.translations.ugcHeaderStepTitle;
    },
    getSubTitle() {
      if (this.getUgcFlowViews[this.getCurrentUgcView] == "ugc-design-view") {
        return this.translations[`ugcHeaderStep${(this.returnPlacementViewOrder + 1)}Subtitle-${this.componentName}`];
      }
      return "";
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    returnPlacementViewOrder() {
      return this.$store.getters["ugc/tempData/getPlacementViewOrder"];
    },
    checkerboarderActive() {
      return this.$store.state.utils.queryParams.feature === 'checkerboarder';
    }
  },
  watch: {
    currentStep(step) {
      this.setDataLayer();
    }
  },
  methods: {
    setDataLayer(step = this.currentStep) {
      if (this.getUgcFlowViews[this.getCurrentUgcView] === "ugc-design-view") {
        const designViewStep = this.getUgcFlowViews.slice(0, this.getCurrentUgcView + 1).filter(i => i === "ugc-design-view").length;
        let action = this.checkerboarderActive ? 'checkerboarder' : 'ugc';
        if (this.$store.state.transferDesign.isCustomizerTransferredModel) {
          action = 'transferDesign';
        }
        if (this.activeUGCIndex === 1 && action === 'ugc') {
          action = 'imageLibrary';
        }
        this.$ugcDataLayer.logAnalyticsEvent({
          action,
          type: this.$ugcDataLayer.types.imageLoaded,
          step: designViewStep,
        });
      }
    },
    showViewDisplayName(text) {
      this.displayViewText = text;
    }
  },
  created() {
    this.$eventBus.$on("show-view-displayName", this.showViewDisplayName);
  },
  mounted() {
    this.setDataLayer();
  },
  beforeDestroy() {
    this.$eventBus.$off("show-view-displayName", this.showViewDisplayName);
  }
};
</script>
